var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('td',{class:_vm.rootClasses,attrs:{"data-label":_vm.label}},[(_vm.$slots.default)?[_vm._t("default")]:[_vm._v("\n    "+_vm._s(_vm.fieldData)+"\n  ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }